module.exports = __webpack_public_path__ + "components/weather-icon/static/nightrainshowers-01577a18760fcc83aa18886b120206b6.webp";